import { Component, OnInit, Input } from '@angular/core';
import { DialogService, LoggerService } from '@wephone-utils';
import { UpdateCrmContactModalComponent } from '@wephone-app-phone/modals/update-crm-contact-modal/update-crm-contact-modal.component';
import { PhoneCall } from '@wephone-app-phone/services';
import { CrmCreateTaskModalComponent } from '@wephone-app-phone/modals/crm-create-task-modal/crm-create-task-modal.component';
import { EnterpriseCrmRepository } from '@wephone-core/model/repository/enterprise_crm';
import { ConfigManager } from '@wephone-core/wephone-core.module';
import { EnterpriseCrmEntity } from '@wephone-core/model/entity/enterprise_crm';

@Component({
  selector: 'app-crm-incall-actions',
  templateUrl: './crm-incall-actions.component.html',
  styleUrls: ['./crm-incall-actions.component.scss']
})
export class CrmIncallActionsComponent implements OnInit {
  @Input() activeCall: PhoneCall;
  private readonly enterpriseCrmRepo = EnterpriseCrmRepository.getInstance();
  types: any[];
  _activeCRM: EnterpriseCrmEntity;
  _crmType: any;
  _displayContactEdit: boolean;
  _displayCreateTask: boolean;

  constructor(
    private readonly dialogService: DialogService,
    public readonly configManager: ConfigManager,
    private readonly loggerService: LoggerService,
  ) { }

  async ngOnInit(): Promise<void> {
    this.enterpriseCrmRepo.findAll(false);
    this.types = await this.configManager.getCrmTypeList();
  }

  get activeCRM(): EnterpriseCrmEntity {
    if (!this._activeCRM && this.activeCall.hasCallData() && this.activeCall.calldata.crm_id) {
      this._activeCRM = this.enterpriseCrmRepo.getObjectById(this.activeCall.calldata.crm_id);
    }

    return this._activeCRM;
  }

  get crmType(): any {
    if (!this._crmType && this.activeCall.hasCallData() && this.activeCall.calldata.crm_id && this.types) {
      const activeCRM = this.enterpriseCrmRepo.getObjectById(this.activeCall.calldata.crm_id);
      if (activeCRM) {
        this._crmType = this.types[activeCRM.type];
      }
    }

    return this._crmType;
  }

  get showDisplayEditContact(): boolean {
    if (!this._displayContactEdit && this.activeCall.hasCallData() && this.activeCall.calldata.crm_id) {
      const activeCRM = this.enterpriseCrmRepo.getObjectById(this.activeCall.calldata.crm_id) as EnterpriseCrmEntity;
      if (activeCRM) {
        this._displayContactEdit = ['salesforce', 'hubspot', 'vtiger', 'zendesk', 'dynamics', 'helpscout'].includes(activeCRM.type);
      }
    }

    return this._displayContactEdit;
  }

  get showDisplayCreateTask(): boolean {
    if (!this._displayCreateTask && this.activeCall.hasCallData() && this.activeCall.calldata.crm_id) {
      const activeCRM = this.enterpriseCrmRepo.getObjectById(this.activeCall.calldata.crm_id) as EnterpriseCrmEntity;
      if (activeCRM) {
        this._displayCreateTask = ['salesforce', 'hubspot', 'vtiger', 'dynamics'].includes(activeCRM.type);
      }
    }

    return this._displayCreateTask;
  }

  get crmClientName(): string {
    if (this.activeCall.calldata && this.activeCall.calldata.crm_contact_id && this.activeCall.calldata.client_name) {
      return this.activeCall.calldata.client_name;
    }
  }

  get isEdit(): boolean {
    return this.activeCall.hasCallData() ? !!this.activeCall.calldata.crm_contact_id : false;
  }

  async openContactProfile(): Promise<void> {
    const url = await this.activeCall.getCrmContactUrl();
    if (url) {
      window.open(url, '_blank');
    }
  }

  updateContact(): void {
    const callInfo = {
      crmId: this.activeCall.hasCallData ? this.activeCall.calldata.crm_id : undefined,
      crmContactId: this.activeCall.hasCallData ? this.activeCall.calldata.crm_contact_id : undefined,
      crmContactType: this.activeCall.hasCallData ? this.activeCall.calldata.crm_contact_type : undefined,
      phoneNumber: this.activeCall.remoteNumberInLocalFormat(),
      userCallId: this.activeCall.hasCallData ? this.activeCall.calldata.user_call_id : undefined,
    };

    const isEdit = callInfo.crmId && callInfo.crmContactId;
    if (!isEdit) {
      this.dialogService.openDialog2(UpdateCrmContactModalComponent, {
        data: { callInfo }
      });
    } else {
      this.openContactProfile().catch((e) => {
        this.loggerService.error('Open contact profile failed', e);
      });
    }
  }

  createTask(): void {
    this.dialogService.openDialog2(CrmCreateTaskModalComponent, {
      data: {
        crmId: this.activeCall.hasCallData ? this.activeCall.calldata.crm_id : undefined,
        contactId: this.activeCall.hasCallData ? this.activeCall.calldata.crm_contact_id : undefined,
        contactType: this.activeCall.hasCallData ? this.activeCall.calldata.crm_contact_type : undefined,
        phoneNumber: this.activeCall.remoteNumberInLocalFormat(),
      }
    });
  }

  doNothing(): void {

  }
}
